import React from 'react';
import BookTourPage from '../components/BookTourPage';
import WhatsAppButton from '../components/WhatsAppButton';

function BookTour() {
  return (
    <div className="home">
      <BookTourPage />
      <WhatsAppButton />
    </div>
  );
}

export default BookTour;
